module.exports = ".line-break {\n  overflow: inherit;\n  text-overflow: inherit;\n  white-space: normal; }\n"